export default function BlockOutlineIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 12C6 8.68629 8.68629 6 12 6C13.2958 6 14.4957 6.41079 15.4765 7.10925L15.2929 7.29289L7.29289 15.2929L7.10925 15.4765C6.41079 14.4957 6 13.2958 6 12ZM8.52347 16.8907C9.50428 17.5892 10.7042 18 12 18C15.3137 18 18 15.3137 18 12C18 10.7042 17.5892 9.50428 16.8907 8.52347L16.7071 8.70711L8.70711 16.7071L8.52347 16.8907ZM12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4Z"
        fill="var(--text-primary-color)"
      />
    </svg>
  );
}
